(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.directive('rfGlobalColoredCaption', ['$compile', RfGlobalColoredCaptionFn]);

    // global display of colored caption
    function RfGlobalColoredCaptionFn($compile) {
        var directive = {
            restrict: 'A',
            link: link
        };
        return directive;

        function link(scope, element, attrs) {
            const textColor = attrs.color === 'white' ? 'dark' : attrs.color;

            const el = $compile(
                '<span class="bg-{{' + attrs.color + '}} mr-2 border border-gray-200">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span> ' +
                '<span style="white-space:normal;" ng-bind="' + attrs.caption + '" ' +
                'ng-style="{\'color\': \'' + textColor + '\'}" class="font-' + textColor + '"></span>'
            )(scope);
            element.append(el);
        }

    }

})();